import React from "react";
import styled from "styled-components";
import Logo from "../../../Assets/img/LogoMMASMblue.png";

const Modal = ({ children, estado, cambiarEstado }) => {
  return (
    <>
      {estado && (
        <Overlay>
          <ContenedorModal>
            <EncabezadoModal>
              <img
                src={Logo}
                alt="Ambiente"
                className="max-w-[20rem] phone:max-w-[76px]"
              />
            </EncabezadoModal>

            {/* <BotonCerrar onClick={() => cambiarEstado(false)}>
              <svg
                className="h-8 w-8 color[#1766dc]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </BotonCerrar> */}
            {children}
          </ContenedorModal>
        </Overlay>
      )}
    </>
  );
};

export default Modal;

const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

const ContenedorModal = styled.div`
  top: 30px;
  width: 50rem;
  position: relative;
  background: #fff;
  border-radius: 5px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  padding: 2rem;
`;

const EncabezadoModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #003670;
  padding-bottom: 10px;
`;

const BotonCerrar = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  border none;
  background none;
  cursor: pointer;
  transition: .3s ease all;
  border-radius: 5px;
  color: #003670;

  svg{
    width: 100%;
    height: 100%;
  }
`;
